<div
  class="resident-budget"
  [ngClass]="theme"
  style="cursor: pointer"
  (click)="moveToResidentPage(resident)"
  *ngIf="!resident.monthlyBudgetValue && showAddBudget">
  <mat-icon class="budget-icon budget-icon-plus" [svgIcon]="'plus'"></mat-icon>
  <span class="text-trim" style="font-size: 12px; color: inherit">
    Jetzt
    <b style="font-size: 12px; color: inherit">Budget</b>
    hinterlegen
  </span>
</div>
<div
  matTooltipPosition="above"
  [matTooltip]="getBudgetText()"
  matTooltipClass="info-tooltip"
  *ngIf="resident.monthlyBudgetValue"
  class="resident-budget"
  [ngClass]="theme">
  <mat-icon
    *ngIf="calculateResidentBudget(resident.id) > 0"
    class="budget-icon check">
    check
  </mat-icon>
  <mat-icon
    *ngIf="calculateResidentBudget(resident.id) < 0"
    class="budget-icon exclamation"
    [svgIcon]="'exclamation'"></mat-icon>
  <span class="text-trim">Restbudget:</span>
  <b
    class="budget-total text-trim"
    style="color: inherit; margin-left: 5px; font-size: 12px">
    €
    {{ calculateResidentBudget(resident.id) | number: '1.2-2' }}
  </b>
</div>
